const footerNavSchema = [
  {
    text: 'Reference',
    link: 'https://developer.paypal.com/reference',
    target: '_self',
  },
  { text: 'PayPal.com', link: 'https://www.paypal.com', target: '_blank' },
  {
    text: 'Privacy',
    link: 'https://www.paypal.com/us/webapps/mpp/ua/privacy-full',
    target: '_blank',
  },
  {
    text: 'Support',
    link: 'https://developer.paypal.com/docs/support',
    target: '_self',
  },
  {
    text: 'Legal',
    link: 'https://www.paypal.com/us/webapps/mpp/ua/legalhub-full',
    target: '_blank',
  },
  {
    text: 'Contact',
    link: 'https://www.paypal.com/us/smarthelp/contact-us',
    target: '_blank',
  },
]

export { footerNavSchema }
